import Cookies from 'js-cookie'

import { TOKEN_KEY } from './constants'

const AUTH_COOKIE_PATH = '/'
const AUTH_COOKIE_PATHS = [
  AUTH_COOKIE_PATH,
  '/admin-indicators',
  '/assistant',
  '/billing',
  '/campaigns',
  '/clients',
  '/companies',
  '/conversations',
  '/crm',
  '/indication-program',
  '/indicators',
  '/journeys',
  '/login',
  '/scheduled-messages',
  '/service-orders',
  '/settings',
  '/tasks',
  '/transmission-lists',
  '/users',
]

function getPossibleCookieDomains() {
  if (typeof window === 'undefined') return [undefined]

  const { hostname } = window.location

  if (hostname === 'localhost' || /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)) {
    return [undefined, hostname]
  }

  const domains = [undefined, hostname]
  const parts = hostname.split('.')

  for (let index = 1; index < parts.length - 1; index += 1) {
    domains.push(`.${parts.slice(index).join('.')}`)
  }

  return Array.from(new Set(domains))
}

export function clearAuthTokenCookie() {
  Cookies.remove(TOKEN_KEY)

  getPossibleCookieDomains().forEach((domain) => {
    AUTH_COOKIE_PATHS.forEach((path) => {
      Cookies.remove(TOKEN_KEY, {
        path,
        ...(domain ? { domain } : {}),
      })
    })
  })
}

export function setAuthTokenCookie(accessToken: string) {
  clearAuthTokenCookie()

  const secure =
    typeof window !== 'undefined' && window.location.protocol === 'https:'

  Cookies.set(TOKEN_KEY, accessToken, {
    expires: 7,
    path: AUTH_COOKIE_PATH,
    sameSite: 'lax',
    secure,
  })
}
